export class CascadingMsalAccountComponentInterop {
    constructor(dotNetMsalCascadingAuthenticationStateDotNetObject) {
        Object.defineProperty(this, "dotNetMsalCascadingAuthenticationStateDotNetObject", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        if (dotNetMsalCascadingAuthenticationStateDotNetObject) {
            this.dotNetMsalCascadingAuthenticationStateDotNetObject = dotNetMsalCascadingAuthenticationStateDotNetObject;
        }
        else {
            throw "dotNetMsalCascadingAuthenticationState is undefined. It must have a value at this point.";
        }
    }
    async onActiveMsalAccountChanged(account) {
        if (this.dotNetMsalCascadingAuthenticationStateDotNetObject) {
            await this.dotNetMsalCascadingAuthenticationStateDotNetObject.invokeMethodAsync("onMsalAccountChanged", account);
        }
        else {
            console.warn("dotNetMsalCascadingAuthenticationStateDotNetObject was undefined!");
        }
    }
}
